const ActionButton = ({
  label,
  onClick,
  variant = "primary",
  className = "",
}) => {
  const base =
    "w-auto md:w-[240px] max-w-full px-4 py-2 md:px-5 md:py-3 rounded-xl md:h-[48px] h-auto font-medium transition-all duration-200";

  const variants = {
    primary: "bg-[#1B3CD6] text-white hover:bg-[#1632b5]",
    outline: "border border-[#1B3CD6] text-[#1B3CD6] hover:bg-[#1B3CD6]/10",
  };

  return (
    <button
      onClick={onClick}
      className={`${base} ${variants[variant]} ${className}`}
    >
      {label}
    </button>
  );
};

export default ActionButton;
